import React, {useState} from 'react';

import FormAccount from "../../Form/FormAccount/FormAccount";
import {getIdWithToken} from "../../../../utils/storage/Token";
import FCAlertMsgErrorAPI from "../../../FCObjets/FCAlertMsg/FCAlertMsgErrorAPI";

const ContentAccount: React.FC = () => {

    const [error, setError] = useState(undefined);

    return (
        <>
            <FormAccount
                onFinished={() => window.location.reload()}
                idUser={getIdWithToken()}
                onError={(e) => setError(e)}
            />
            {error && <FCAlertMsgErrorAPI error={error}/>}
        </>
    );
};

export default ContentAccount;
